import { createContext, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useAuth } from '@clerk/clerk-react';
import useEmbeddedAuth from '@/hooks/useEmbeddedAuth.js';

import selectors from '@/redux/selectors/selectors';

export const AuthContext = createContext();

const loadedStatusFactory = () => {
  let isLoaded = false;

  return {
    setToIsLoaded: () => {
      isLoaded = true;
    },
    getIsLoaded: () => {
      return isLoaded;
    }
  };
};

const loadedStatusGlobalKey = '__mindcloudReactLoadedStatus';
const loadedStatus = globalThis[loadedStatusGlobalKey] || loadedStatusFactory();
globalThis[loadedStatusGlobalKey] = loadedStatus;
export { loadedStatus };

const AuthProvider = (props) => {
  const isLoggedIn = useSelector(selectors.loggedIn);
  const activeRouteId = useSelector((state) => state.ui.activeRouteId);
  const { isLoaded, isSignedIn } = useAuth();
  const { isEmbeddedEndUser, isEmbeddedValid, isValidating } = useEmbeddedAuth();

  const isOauthRoute = useMemo(() => activeRouteId === 'oauth', [activeRouteId]);

  const shouldUseEmbeddedAuth = isOauthRoute && isEmbeddedEndUser && isEmbeddedValid;

  useEffect(() => {
    if (isLoaded) {
      loadedStatus.setToIsLoaded();
    }
  }, [isLoaded]);

  const contextValue = {
    isLoaded: isOauthRoute ? isLoaded && !isValidating : isLoaded,
    isLoggedIn: isLoggedIn || isSignedIn || shouldUseEmbeddedAuth,
    isEmbeddedEndUser: shouldUseEmbeddedAuth
  };

  return <AuthContext.Provider value={contextValue}>{props.children}</AuthContext.Provider>;
};

export default AuthProvider;
